// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Js_array from "rescript/lib/es6/js_array.js";
import * as Js_string from "rescript/lib/es6/js_string.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Belt_MapString from "rescript/lib/es6/belt_MapString.js";

function queryStringHasField(searchParams, field) {
  return new URLSearchParams(searchParams).has(field);
}

function queryStringGetField(searchParams, field) {
  return Caml_option.nullable_to_opt(new URLSearchParams(searchParams).get(field));
}

function queryStringGetAllFields(searchParams) {
  return Array.from(new URLSearchParams(searchParams).entries());
}

function queryStringRemoveField(searchParams, field) {
  var params = new URLSearchParams(searchParams);
  params.delete(field);
  var cleansedParamString = params.toString();
  if (cleansedParamString === "") {
    return "";
  } else {
    return "?" + cleansedParamString + "";
  }
}

function queryStringSetField(searchParams, field, value) {
  var params = new URLSearchParams(searchParams);
  params.set(field, value);
  var cleansedParamString = params.toString();
  if (cleansedParamString === "") {
    return "";
  } else {
    return "?" + cleansedParamString + "";
  }
}

var $$Location = {
  queryStringHasField: queryStringHasField,
  queryStringGetField: queryStringGetField,
  queryStringGetAllFields: queryStringGetAllFields,
  queryStringRemoveField: queryStringRemoveField,
  queryStringSetField: queryStringSetField
};

function getCurrentParams(param) {
  return Array.from(new URL(window.location.toString()).searchParams.entries());
}

function urlWithCustomQueryString($$location, queryString) {
  return $$location.protocol + "//" + $$location.host + $$location.pathname + queryString + $$location.hash;
}

function replaceState(url) {
  var state = window.history.state;
  window.history.replaceState(state, "", url);
}

var $$History = {
  replaceState: replaceState
};

function getQueryString(param) {
  return window.location.search;
}

function cleanQueryString(queryString) {
  return Js_string.replaceByRe(/^\?(.*)$/, "$1", queryString);
}

function queryParameters(queryString) {
  return Belt_Array.reduce(Js_string.split("&", cleanQueryString(queryString)), undefined, (function (accumulated, parameters) {
                var maybeParameters = Js_string.split("=", parameters);
                var key = Belt_Array.get(maybeParameters, 0);
                if (key !== undefined) {
                  return Belt_MapString.set(accumulated, key, Js_array.joinWith("", Belt_Array.sliceToEnd(maybeParameters, 1)));
                } else {
                  return accumulated;
                }
              }));
}

var isQueryParameterSet = Belt_MapString.has;

var getQueryParameterValue = Belt_MapString.get;

function getQueryParameters(param) {
  return queryParameters(window.location.search);
}

var QueryString = {
  getQueryString: getQueryString,
  cleanQueryString: cleanQueryString,
  queryParameters: queryParameters,
  isQueryParameterSet: isQueryParameterSet,
  getQueryParameterValue: getQueryParameterValue,
  getQueryParameters: getQueryParameters
};

export {
  $$Location ,
  getCurrentParams ,
  urlWithCustomQueryString ,
  $$History ,
  QueryString ,
}
/* No side effect */
